module.exports = __webpack_public_path__ + "static/media/logo.1951648a.jpg";